import { Datepicker } from 'vanillajs-datepicker';
import de from 'vanillajs-datepicker/locales/de';

// Merge languages
Object.assign(Datepicker.locales, de);

// Initialize all datepickers
const inputs = document.querySelectorAll('input.has-datepicker');
if (inputs) {
  inputs.forEach((input) => {
    new Datepicker(input, {
      language: 'de',
    });
  });
}
